import React from 'react';

import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

if (
  !process.env.REACT_APP_AUTH_DOMAIN ||
  !process.env.REACT_APP_AUTH_CLIENT_ID ||
  !process.env.REACT_APP_BFF_AUDIENCE
) {
  throw new Error('Missing Auth0 configuration');
}

interface Props {
  children?: React.ReactNode | React.ReactNode[];
}

const Auth0ProviderWithHistory: React.FC<Props> = (props) => {
  const { children } = props;
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH_DOMAIN || ''}
      clientId={process.env.REACT_APP_AUTH_CLIENT_ID || ''}
      redirectUri={window.location.origin}
      audience={process.env.REACT_APP_BFF_AUDIENCE || ''}
      onRedirectCallback={onRedirectCallback}
      // Persist tokens across refresh and renew via refresh tokens instead of
      // relying on third-party cookies in a hidden iframe (often blocked).
      // Requires Refresh Token Rotation on the Auth0 SPA application.
      // (SDK auto-adds offline_access when useRefreshTokens is true.)
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
